<template>
  <div class="container">
    <div class="row">
      <div class="col-7">
        <!--Columna izquierda -->
        <h2 class="header">
          <i class="fas fa-drumstick-bite"></i> {{ accion }} Producto
        </h2>
        <table v-if="producto" class="table" style="background:#FFF">
          <tbody>
            <tr>
              <th class="text-right">Id</th>
              <td>{{ producto.id }}</td>
            </tr>
            <tr>
              <th class="text-right">Nombre</th>
              <td>{{ producto.nombre }}</td>
            </tr>
            <tr>
              <th class="text-right">Clave</th>
              <td>{{ producto.clave }}</td>
            </tr>
            <tr>
              <th class="text-right">Modificado</th>
              <td>{{ producto.modified | dateTime }}</td>
            </tr>
            <tr>
              <th class="text-right">Unidad de Medida</th>
              <td>{{ producto.unit_medida }}</td>
            </tr>
            <tr v-for="(precio, k) in producto.precios" :key="k">
              <th class="text-right">
                Precio {{ tipo_nombre(precio.tipo_cliente_id) }}
              </th>
              <td>$ {{ precio.precio }}</td>
            </tr>
            <tr>
              <th colspan="2" class="text-center header">
                <h2>
                  <i class="fas fa-pencil-alt"></i>
                  Rellena los campos para publicar
                </h2>
              </th>
            </tr>
            <tr>
              <th>Descripción:</th>
              <td>
                <textarea
                  v-model="form.descripcion"
                  class="form-control"
                  rows="3"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>Precio:</th>
              <td>
                <div class="col-auto">
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="number"
                      class="form-control"
                      v-model="form.precio"
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>Existencia:</th>
              <td>
                <div class="col-auto">
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="fa fa-list-alt"></i>
                      </div>
                    </div>
                    <input
                      type="number"
                      class="form-control"
                      min="1"
                      v-model="form.stock"
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                Imagen
                <button @click="showModalImgInfo" id="btn-info">
                  <i class="fas fa-info-circle"></i>
                </button>
              </th>
              <td>
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    accept="image/x-png,image/gif,image/jpeg"
                    id="form-img"
                    @change="cargarImg"
                    required
                  />
                  <label class="custom-file-label" for="imagenProducto">
                    <span v-if="img.label">
                      {{ img.label }}
                    </span>
                    <b-spinner v-else variant="primary" label="Spinning">
                    </b-spinner>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!--Columna izquierda -->
      </div>
      <div class="col-5">
        <SmarthPhone>
          <div class="row" id="producto-smarth-details" v-if="producto">
            <div class="col col-img" @click="openSelectorImg">
              <img v-if="img.upload" :src="img.src" class="img-fluid rounded" />
              <img
                v-else
                :src="img.srcDemo"
                class="img-fluid rounded"
                style="width:100%"
              />
            </div>
            <div class="col">
              <h6 class="producto-nombre">
                {{ producto.nombre }}
              </h6>
              <p>{{ form.descripcion }}</p>
              <p class="text-right font-weight-bold precio">
                $ {{ form.precio }} / {{ producto.unit_medida }}
              </p>
              <p class="text-right font-weight-bold">
                {{ form.stock }} {{ producto.unit_medida }} disponible
              </p>
              <button class="btn btn-sm btn-primary btn-detalles">
                Detalles
              </button>
            </div>
          </div>
          <!-- -->
          <small
            style="color:#666;padding:0 1rem;border-bottom:1px solid #CCCC; display:block;margin-bottom:1rem"
          >
            Previo de como se vería en un telefono móvil
          </small>
          <div class="row no-gutters" style="padding:0 1rem">
            <div class="col">
              <router-link
                class="btn btn-dark btn-lg btn-block"
                :to="{ name: 'Dashboard' }"
              >
                <i class="fas fa-hand-point-left"></i> Regresar
              </router-link>
            </div>
            <div class="col">
              <button
                class="btn btn-secondary btn-lg btn-block"
                :class="{ 'btn-warning': !disabledBtnPublicar }"
                :disabled="disabledBtnPublicar"
                v-on:click="publicar"
              >
                <i class="fas fa-check"></i> Publicar
              </button>
            </div>
          </div>
          <!-- -->
        </SmarthPhone>
      </div>
    </div>
    <!-- Inicio del modal -->
    <b-modal id="modal-info-img" hide-footer>
      <template v-slot:modal-title>
        Agrega una imagen para el producto
      </template>
      <div class="d-block text-center">
        <div class="row">
          <div class="col">
            <img
              :src="img.srcDemo"
              class="img-fluid rounded"
              style="width:100%"
            />
          </div>
          <div class="col">
            <h5>Las dimensiones debe ser de <code>640x450</code> pixeles</h5>
            <b-alert show variant="danger" v-if="img.labelSizeError">
              <i class="fas fa-exclamation-triangle"></i>
              {{ img.labelSizeError }}
            </b-alert>
            <button
              class="btn btn-primary btn-block btn-lg"
              @click="openSelectorImg"
            >
              <i class="fas fa-cloud-upload-alt"></i> Seleccionar Imagen
            </button>
          </div>
        </div>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('modal-info-img')">
        Cerrar
      </b-button>
    </b-modal>
    <!-- Inicio del modal -->
  </div>
</template>

<style lang="scss">
#btn-info {
  border: none;
  background: white;
}
.fa-info-circle {
  color: #904b57;
  cursor: pointer;
}
.custom-file {
  cursor: pointer;
}

#producto-smarth-details {
  background: #efefef;
  margin: 1rem;
  border-style: dotted;
  border-color: #ddd;
  .col {
    font-size: 0.8rem;
    padding: 0.5rem 0.3rem;
  }
  .col.col-img {
    cursor: pointer;
  }
  .producto-nombre {
    color: #333;
  }
  .precio {
    font-size: 1rem;
    color: #990000;
  }
  .btn-detalles {
    float: right;
  }
}
</style>

<script>
import SmarthPhone from "@/components/smarthPhone.vue";
import Producto from "../../apis/Producto";

export default {
  data() {
    return {
      accion: "Publicar",
      producto: null,
      tipos_de_clientes: [],
      form: {
        producto_id: 0,
        descripcion: "",
        precio: 0,
        stock: 10,
        editar: false
      },
      img: {
        label: "Seleccione una imagen",
        labelSizeError: false,
        srcDemo: "",
        src: null,
        upload: false
      }
    };
  },
  created() {
    Producto.ver(this.$route.params.id).then(r => {
      this.producto = r.data.producto;
      this.form.producto_id = this.producto.id;
      // Tomamos el precio mayor
      for (let i = 0; i < this.producto.precios.length; i++) {
        if (this.form.precio < this.producto.precios[i].precio) {
          this.form.precio = this.producto.precios[i].precio;
        }
      }
      this.img.srcDemo = Producto.baseURL() + "/productos/image_icon.svg";
      this.tipos_de_clientes = r.data.tipos_de_clientes;
      if (this.producto.publicado) {
        Object.assign(this.form, this.producto.publicado);
        this.accion = "Editar";
        this.img.src =
          Producto.baseURL() + "/productos/" + this.producto.id + ".png";
        this.img.upload = true;
        this.form.editar = true;
      }
    });
  },
  components: {
    SmarthPhone
  },
  methods: {
    tipo_nombre(tipo_id) {
      for (let i = 0; i < this.tipos_de_clientes.length; i++) {
        if (this.tipos_de_clientes[i].id == tipo_id) {
          return this.tipos_de_clientes[i].nombre;
        }
      }
      return "id:" + tipo_id;
    },
    cargarImg() {
      this.img.label = this.img.upload = this.img.labelSizeError = false;
      let formData = new FormData();
      let imagefile = document.querySelector("#form-img");
      let orignalName = imagefile.files[0].name;
      formData.append("img", imagefile.files[0]);
      formData.append("producto_id", this.form.producto_id);
      Producto.publicar(formData).then(r => {
        this.img.label = orignalName;
        if (Object.prototype.hasOwnProperty.call(r.data, "errors")) {
          this.showModalImgInfo();
          this.img.labelSizeError = r.data.errors[1];
          return;
        }
        this.img.upload = true;
        this.img.src = Producto.baseURL() + r.data + "?" + new Date().getTime();
      });
    },
    // Se encarga de hacer publico un producto
    publicar() {
      let formData = new FormData();
      formData.append("producto", JSON.stringify(this.form));
      Producto.publicar(formData)
        .then(() => {
          /// Inicio toas que notifica el cambio
          this.$bvToast.toast(`Producto ${this.producto.nombre}`, {
            title: "Cambios guardados",
            variant: "info",
            autoHideDelay: 3000
          });
          setTimeout(() => {
            this.$router.push({ name: "Dashboard" });
          }, 5500);
          // fin toas
        })
        .catch(() => {
          alert("error enviando datos");
        });
    },
    // Muestra el modal donde se encuntra la información del tamaño de imagen
    showModalImgInfo() {
      this.$bvModal.show("modal-info-img");
    },
    // Abre el selector de archivos para seleccinar la imagen a cargar.
    openSelectorImg() {
      this.$bvModal.hide("modal-info-img");
      document.getElementById("form-img").click();
    }
  }, // end methods
  computed: {
    disabledBtnPublicar() {
      return (
        this.producto == null ||
        this.form.precio <= 0 ||
        this.descripcion == "" ||
        this.img.upload == false
      );
    }
  }
};
</script>
